import React from "react";
import { Routes, Route } from "react-router-dom";
import EmployeeDashboard from "../../EmpDashboard/Pages/EmployeeDashboard";
// import ReportIssue from "../../ReportIssue/Pages/ReportIssue";

const EmployeeRoutes = () => {
  return (
    <Routes>
        <Route index element={<EmployeeDashboard />} />
    </Routes>
  );
};

export default EmployeeRoutes;
